import React from 'react';
import { Box } from 'components';

import styles from './ButtonsBlock.less';

type ButtonsBlockProps = {
  children: React.ReactNode;
};

const ButtonsBlock: React.SFC<ButtonsBlockProps> = ({ children }): JSX.Element => (
  <Box justify="right" align="center" className={styles.block}>
    {children}
  </Box>
);

export default ButtonsBlock;
